
import React from "react";
import { NavLink} from "react-router-dom";

export class TrackHeaderLink extends React.Component {

render() {
  return(
      <ul className="nav justify-content-end top-submenu">
        <li className="nav-item">
           <NavLink activeClassName="active" to="/dashboard/quotes/">Quotes</NavLink>
        </li>
        <li>
          <NavLink activeClassName="active" to="/dashboard/work-order/">Work Orders</NavLink>
        </li>
        <li>
          <NavLink activeClassName="active" to="/dashboard/hotsheet/">Hotsheet Management</NavLink>
        </li>
         <li>
          <NavLink activeClassName="active" to="/dashboard/work-performed/">Work Performed</NavLink>
        </li>
        <li>
          <NavLink activeClassName="active" to="/dashboard/report/">Report</NavLink>
        </li>
        <li>
          <NavLink activeClassName="active" to="/dashboard/data-management/">Data Management</NavLink>
        </li>
          <li>
          <NavLink activeClassName="active" to="/dashboard/waste-profiles/">Waste Profiles</NavLink>
        </li>
        <li>
          <NavLink activeClassName="active" to="/dashboard/trash/">Trash</NavLink>
        </li>
        <li>
          <NavLink activeClassName="active" to="/dashboard/draft/">Draft</NavLink>
        </li>
      </ul>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/tracks/TrackHeaderLink.jsx